import { AddEditContactFormValues } from '../types';

export const VALID_PHONE_TYPES = {
  MOBILE: 'Mobile',
  HOME: 'Home',
  WORK: 'Work',
};

export const ADD_EDIT_CONTACT_FORM_INITIAL_VALUES: AddEditContactFormValues = {
  name: '',
  title: '',
  email: '',
  phones: [
    {
      phone: '',
      type: VALID_PHONE_TYPES.MOBILE,
    },
  ],
  groups: [],
  nameYourGroup: '',
  website: '',
  notes: '',
  address: '',
};
